import { GxBigCalendarEventPropGetter } from "@/components/molecules/GxBigCalendar";
import {
  ChargerUsageStatusColorType,
  EventBgColor,
  EventFontColor,
} from "@/models/chargePlans";
import { getJSTTime } from "@/util/datetime";

export const ChargerUsageStatusConstants = {
  UsageStatus: "充電器利用状況",
  OfficeName: "設置場所（会社／営業所）",
  ChargerName: "充電器名",
} as const;

const colorMap: Readonly<{
  [key in ChargerUsageStatusColorType]: Readonly<
    [EventBgColor, EventFontColor]
  >;
}> = {
  suspension: ["grey", "black"],
  charger_quick: ["lime", "black"],
  charger_standard: ["blue", "white"],
  charger_other_quick: ["orange", "black"],
  charger_other_standard: ["orange", "black"],
  status_charger_quick: ["purple", "white"],
  supply_charger_quick: ["purple", "white"],
  status_charger_standard: ["darkcyan", "white"],
  supply_charger_standard: ["darkcyan", "white"],
  status_charger_other_quick: ["navy", "white"],
  supply_charger_other_quick: ["navy", "white"],
  status_charger_other_standard: ["navy", "white"],
  supply_charger_other_standard: ["navy", "white"],
  status_unknown_quick: ["purple", "white"],
  supply_unknown_quick: ["purple", "white"],
  status_unknown_standard: ["darkcyan", "white"],
  supply_unknown_standard: ["darkcyan", "white"],
};

const editTimeRange = (
  color: ChargerUsageStatusColorType,
  start: string | Date,
  end: string | Date
) => {
  const startStr = getJSTTime(new Date(start), "datetime").slice(11, 16);
  const endStr = getJSTTime(new Date(end), "datetime").slice(11, 16);

  if (color.includes("status")) {
    return `実績 ${startStr} – (充電中)`;
  }

  if (color.includes("supply")) {
    return `実績 ${startStr} – ${endStr}`;
  }

  if (color.startsWith("charger")) {
    return `予約 ${startStr} – ${endStr}`;
  }

  return undefined;
};

export const chargerUsageStatusEventPropGetter: GxBigCalendarEventPropGetter<
  ChargerUsageStatusColorType
> = ({ color, start, end }) => ({
  backgroundColor: colorMap[color][0],
  fontColor: colorMap[color][1],
  customEventTimeRange: editTimeRange(color, start, end),
});

export const EMPTY_EVENT_BODY_COLORS: ChargerUsageStatusColorType[] = [
  "status_charger_standard",
  "supply_charger_standard",
  "status_charger_other_standard",
  "supply_charger_other_standard",
  "status_unknown_standard",
  "supply_unknown_standard",
  "status_unknown_quick",
  "supply_unknown_quick",
];

export const OutputControl = {
  Label: "出力コントロール",
  CancelSuccess: "出力コントロールの解除に成功しました。",
  CancelFailed: "出力コントロールの解除に失敗しました。",
} as const;
